var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 131,
    viewBox: "0 0 135 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "WP"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 131,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 130,
    rx: 9.5,
    stroke: "#3A3A3A",
    strokeOpacity: 0.1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.5 92C82.1355 92 94 80.1355 94 65.5C94 50.8645 82.1355 39 67.5 39C52.8645 39 41 50.8645 41 65.5C41 80.1355 52.8645 92 67.5 92Z",
    fill: "url(#paint0_linear_4872_45999)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.8695 66.7963C53.9674 65.0899 57.4254 63.6658 60.6564 62.2343C66.215 59.8898 71.7957 57.5858 77.4327 55.4408C78.5293 55.0754 80.5 54.7181 80.6933 56.3434C80.5875 58.644 80.1522 60.9312 79.8537 63.2184C79.096 68.2481 78.2199 73.2606 77.366 78.2737C77.0716 79.9434 74.9799 80.808 73.6414 79.7394C70.4247 77.5666 67.1833 75.415 64.0078 73.1919C62.9674 72.1347 63.9322 70.617 64.8611 69.8621C67.5104 67.251 70.3201 65.033 72.8309 62.2871C73.5082 60.6514 71.507 62.0299 70.847 62.4523C67.22 64.9517 63.6818 67.6037 59.8579 69.8003C57.9046 70.8756 55.628 69.9567 53.6756 69.3567C51.9251 68.6319 49.3599 67.9016 50.8693 66.7965L50.8695 66.7963Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4872_45999",
    x1: 76.3355,
    y1: 47.8351,
    x2: 63.0855,
    y2: 78.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramInactive);
export default __webpack_public_path__ + "static/media/telegramInactive.25f328fb2eed743d7224fe1d8bee76c0.svg";
export { ForwardRef as ReactComponent };